import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

interface IModalBodyProps extends TestingProps {
  children?: React.ReactNode;
  className?: string;
}

export const ModalBody: React.FunctionComponent<IModalBodyProps> = (props) => {
  return (
    <div
      className={C('modal-body rc-p-4 rc-z-[3000]', props.className)}
      data-testid={props.testId}
    >
      {props.children}
    </div>
  );
};
